import Vue from 'vue';

import { get, cloneDeep } from '@/helpers';

import MenuApi from '@/store/api/menu';
import PageApi from '@/store/api/page';

// initial state
const state = {
  title: '',
  view: '',
  reference: undefined,
  sections: []
};

const getters = {
  sections: state => {
    let sections = get(state, 'sections') || [];
    return cloneDeep(sections).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
  },
  view: state => state.view,
  reference: state => state.reference,
  comments: state => state.comments,
  id: state => state.id
};

// mutations
const mutations = {
  setPage(state, page) {
    Vue.set(state, 'title', page.title);
    Vue.set(state, 'view', page.view);
    Vue.set(state, 'reference', page.reference);
    Vue.set(state, 'sections', page.sections);
  },
  unsetPage(state) {
    Vue.set(state, 'title', '');
    Vue.set(state, 'view', '');
    Vue.set(state, 'reference', undefined);
    Vue.set(state, 'sections', []);
  },
  updateTeasersLoading(state, { s, value }) {
    Vue.set(state.sections[s].teasers, 'loading', value);
  },
  insertTeasers(state, { s, teasers }) {
    Vue.set(state.sections[s], 'teasers', teasers);
  }
  // insertTeaserFilters(state, { s, filters }) {
  //   Vue.set(state.sections[s].teasers.pagination, 'filters', filters);
  // },
};

// actions
const actions = {
  // eslint-disable-next-line no-unused-vars
  fetchMenuItem({ commit }, { path, cms }) {
    return MenuApi.fetchItem(path, cms);
    // .then(data => commit('setPage', data))
  },
  // eslint-disable-next-line no-unused-vars
  fetchCategoryPostTeasers({ commit }, payload) {
    return PageApi.fetchPagesPaginated(payload);
  },
  // eslint-disable-next-line no-unused-vars
  fetchCategoryPost({ commit }, payload) {
    return PageApi.fetchPage(payload);
  }
};

export default {
  namespaced: false,

  state,
  getters,
  actions,
  mutations
};
